import { CSSProperties, FC } from 'react'

import { SquareMonitor } from '../StyledComponents'

interface StatusMonitorProps {
  value?: string | number
  label: string
  labelColor?: CSSProperties['color']
  onClick?: () => void
  isActive?: boolean
}

const StatusMonitor: FC<StatusMonitorProps> = ({ value, label, labelColor, onClick, isActive }) => {
  return (
    <SquareMonitor
      onClick={onClick}
      style={{
        backgroundColor: isActive ? '#e9e9e9' : undefined,
        cursor: 'pointer',
      }}
    >
      <span>{value ?? '--'}</span>
      <span style={{ color: labelColor }}>{label}</span>
    </SquareMonitor>
  )
}

export default StatusMonitor
